/**
 * Haversine 공식으로 두 좌표 간 직선거리(km) 계산
 */
export function haversineDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371; // 지구 반지름 (km)
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function toRad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * 도로거리 추정 (직선거리 × 1.3)
 * TODO: 카카오 모빌리티 Directions API 연동 시 실제 도로거리로 교체
 */
export async function getRoadDistance(
  originLat: number,
  originLng: number,
  destLat: number,
  destLng: number
): Promise<number> {
  const straightDistance = haversineDistance(originLat, originLng, destLat, destLng);
  return Math.round(straightDistance * 1.3 * 10) / 10;
}
